import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

// Components
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Programs from './pages/Programs/Programs';
import EducationDetail from './pages/Programs/EducationDetail';
import DistrictDetail from './pages/Programs/DistrictDetail';
import FoodDetail from './pages/Programs/FoodDetail';
import TechnologyDetail from './pages/Programs/TechnologyDetail';
import EldersScheme from './pages/Programs/EldersScheme';
import StudentsScheme from './pages/Programs/StudentsScheme';
import MobileComputerCamp from './pages/Programs/MobileComputerCamp';
import ComputerTrainingClass from './pages/Programs/ComputerTrainingClass';
import Gallery from './pages/Gallery/Gallery';
import Contact from './pages/Contact/Contact';
import Donate from './pages/Donate/Donate';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/programs" element={<Programs />} />
        <Route path="/programs/education" element={<EducationDetail />} />
        <Route path="/programs/education/district/:districtId" element={<DistrictDetail />} />
        <Route path="/programs/food" element={<FoodDetail />} />
        <Route path="/programs/food/elders" element={<EldersScheme />} />
        <Route path="/programs/food/students" element={<StudentsScheme />} />
        <Route path="/programs/technology" element={<TechnologyDetail />} />
        <Route path="/programs/technology/mobile-camp" element={<MobileComputerCamp />} />
        <Route path="/programs/technology/training-class" element={<ComputerTrainingClass />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
      <ScrollToTop />
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default App;
